import depo from '../services/depo'; // GF1: try/catch'li localStorage sarmalayıcısı (3. taraf iframe)
import Vuex from 'vuex'

export const UserData = new Vuex.Store({
  state: {
    token: depo.oku('token'),
    tokenExpiration: depo.oku('tokenExpiration'),
    refreshToken: depo.oku('refreshToken'),
  },
  actions: {
    setaccessToken ({ commit }, payload) {
      // Payload string ise eski format (backwards compatibility)
      if (typeof payload === 'string') {
        depo.yaz('token', payload)
        commit('_TOKEN', payload)
      } else {
        // Yeni format: { token, expirationTime }
        depo.yaz('token', payload.token)
        if (payload.expirationTime) {
          depo.yaz('tokenExpiration', payload.expirationTime)
          commit('_TOKEN_EXPIRATION', payload.expirationTime)
        }
        commit('_TOKEN', payload.token)
      }
    },
    setRefreshToken ({ commit }, refreshToken) {
      depo.yaz('refreshToken', refreshToken)
      commit('_REFRESH_TOKEN', refreshToken)
    },
  },
  mutations: {
    _TOKEN (state, Value) { state.token = Value },
    _TOKEN_EXPIRATION (state, Value) { state.tokenExpiration = Value },
    _REFRESH_TOKEN (state, Value) { state.refreshToken = Value },
  },
  getters: {
    getuserData: state => { return state.token },
    getTokenExpiration: state => { return state.tokenExpiration },
    getRefreshToken: state => { return state.refreshToken },
  }

})